import React, { useState, useEffect } from "react";
import { countBy } from 'lodash';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { color } from 'chart.js/helpers';
import { Doughnut } from "react-chartjs-2"
import autocolors from 'chartjs-plugin-autocolors';

ChartJS.register(ArcElement, Tooltip, Legend, autocolors);

const lighten = (colorData, value) => color(colorData).lighten(value).rgbString();
function DoughnutChart({ item, fixedS1, hideControls }) {
    const [label, setLabel] = useState('')
    const [data, setData] = useState([])
    const options = {
        plugins: {
            autocolors: {
                mode: 'data',
                customize(context) {
                    const colors = context.colors;
                    return {
                        background: lighten(colors.background, 0.5),
                        border: lighten(colors.border, 0.5)
                    };
                }
            }
        }
    }

        useEffect(() => {
            var keysInit;
            if (item.length > 0) {
                keysInit = Object.keys(item[0])
                var c1 = fixedS1 && keysInit.indexOf(fixedS1) !== -1 ? fixedS1 : keysInit[0]
                setLabel(c1)
                changeHandler(c1)
            }

        }, [item, fixedS1])

    const changeHandler = (value) => {

        setData([])
        setLabel(value)
        var dataFilter = item.map((item) => {
            return { 'label': [`${value}`], 'value': item[`${value}`] }
        })

        var uniqueData = getUniqueData(Object.entries(dataFilter))

        var counted = countBy(dataFilter, (d) => {
            return d.value;
        })

        uniqueData.map((item) => {
            setData(data => ([...data, {
                'label': item.value, 'value': counted[item.value]
            }]))
        })


    }


    function getUniqueData(formats) {
        var unique = [];
        return formats.reduce(function (a, b) {
            if (unique.indexOf(b[1].value) === -1) {
                unique.push(b[1].value);
                a.push(b[1]);
            }
            return a;
        }, []);
    }

    return (

        <>
            {!hideControls && (
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 form-group">
                        <label className="paragraph-graph">Serie</label>
                        <select className="form-control paragraph-graph" onChange={(event) => changeHandler(event.target.value)} value={label}>
                            <option value="">Seleccione uno</option>
                            {Object.keys(item).length ? Object.keys(item[0]).map((item) => {
                                return (
                                    <option value={item}>{item}</option>
                                )
                            }) : null}
                        </select>
                    </div>
                </div>
            </div>
            )}

            <Doughnut
                options={options}
                data={{
                    labels: data.map((item) => item.label),
                    datasets: [
                        {
                            label: label,
                            data: data.map((item) => item.value)
                        }],

                }} />
        </>
    )

}

export default DoughnutChart